export const messages = {
  ieException: 'Ľutujeme, sekciu nie je možné zobraziť v prehliadači Internet Explorer',
  loading: 'Načítava sa aplikácia ...'
};
